import { io } from "socket.io-client";
import { createContext } from "react";
let sockettemp;
if (process.env.NODE_ENV !== "production") {
  sockettemp = io({ path: "/api/socketio/" });
} else {
  sockettemp = io("https://socket.nice2win.com", { path: "/api/socketio/" });
}
export const socket = sockettemp;
export const SocketContext = createContext();
